import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Settings, Zap, ShieldCheck, Activity } from "lucide-react";
import "./FactorySection.css";
import factoryImg from "../assets/home-page.jpg";

const FactorySection = () => {
  return (
    <section className="unique-factory-wrap">
      <div className="unique-container">
        
        {/* Left: Interactive Visual Stack */}
        <div className="visual-stack">
          <div className="main-image-frame">
            {/* Rotating Watermark */}
            <div className="watermark-circle">
              <svg viewBox="0 0 200 200">
                <path
                  id="circlePath"
                  d="M 100, 100 m -75, 0 a 75,75 0 1,1 150,0 a 75,75 0 1,1 -150,0"
                  fill="transparent"
                />
                <text>
                  <textPath xlinkHref="#circlePath" className="watermark-text">
                    ESTABLISHED • 1993 • FLOWTECH • EXCELLENCE •
                  </textPath>
                </text>
              </svg>
            </div>

            <img
              src={factoryImg}
              alt="Flowtech Pumps and Motors Factory"
              className="factory-main"
            />

            {/* Floating Nodes - Hidden on very small screens for better UX */}
            <motion.div
              animate={{ y: [0, -15, 0] }}
              transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
              className="tech-node node-precision"
            >
              <Settings size={18} className="icon-blue" />
              <span>PRECISION</span>
            </motion.div>

            <motion.div
              animate={{ y: [0, 15, 0] }}
              transition={{ duration: 5, repeat: Infinity, ease: "easeInOut", delay: 1 }}
              className="tech-node node-performance"
            >
              <Zap size={18} className="icon-gold" />
              <span>PERFORMANCE</span>
            </motion.div>

            <div className="experience-tag">30+ Years Experience</div>
          </div>
        </div>

        {/* Right Content */}
    <div className="content-stack">
  <span className="top-label">INDUSTRIAL & FACTORY</span>

  <h1 className="main-title">
    FLOWTECH <br />
    <span className="blue-gradient">PUMPS & MOTORS</span>
  </h1>

  {/* Highlight intro */}
  <h6 className="intro-text">
  Welcome to Industrial & Factory
</h6>


  {/* Description */}
  <p className="description">
    FLOWTECH PUMPS AND MOTORS (formerly known as Flowwell Pumps & Meters) is a
    leading manufacturer of Transformer Oil Pumps of various models and duty.
    The company commenced manufacturing operations in August 1993 and later
    expanded into Traction & Non-Traction Transformer Oil Pumps, Sealless
    Canned Motor Pumps, Marine Centrifugal Pumps, Self-Priming Monoblock Pumps,
    and Process Pumps under the brand name <strong>FLOWWELL</strong> with effect
    from April 2017.
  </p>

  <div className="feature-row">
    <div className="feat">
      <ShieldCheck size={18} className="icon-blue" />
      <span>Certified Quality</span>
    </div>
    <div className="feat">
      <Activity size={18} className="icon-blue" />
      <span>Zero Leakage</span>
    </div>
  </div>

  <Link to="/services" className="discover-btn">
    Read More
  </Link>
</div>



      </div>
    </section>
  );
};

export default FactorySection;